'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatButton } from '@blocks-react/components/Button';
import { CatIconArrowBack } from '@blocks-react/components/Icons/ArrowBack';
import { useEffect, useRef } from 'react';
import cx from 'classnames';
export const DrawerBackHeader = ({ children, className, handleClose, isActive = false, hideBackButton = false }) => {
    const buttonRef = useRef(null);
    //setTimeout because we need to wait for the drawer/modal to open to apply the focus
    useEffect(() => {
        if (isActive && buttonRef) {
            setTimeout(() => {
                buttonRef.current?.focus();
            }, 250);
        }
    }, [isActive, buttonRef]);
    return (_jsxs("div", { slot: "header", className: `${className} cat-u-display-flex`, style: { gap: '8px' }, children: [_jsx(CatButton, { variant: "ghost", hideText: true, className: cx({ 'd-none': hideBackButton }), onClick: handleClose, ref: buttonRef, children: _jsx(CatIconArrowBack, { slot: "before" }) }), children] }));
};
